import { useCallback } from 'react';

import { useAuthStore } from '@@scripts/store/useAuthStore';
import { useDevToolbarSmartUserRole } from '@@scripts/store/useDevToolbarStore';

import { type UserRole } from '../constants';
import { isAuthorized as isRoleAuthorized } from '../utils/isAuthorized';

const useAuthorization = () => {
    const currentUserRole = useDevToolbarSmartUserRole();
    const authUserRole = useAuthStore((state) => state.userRole);

    const userRole = currentUserRole || authUserRole;

    const isAuthorized = useCallback(
        (userRoles: UserRole[] | undefined) => isRoleAuthorized(userRole, userRoles),
        [userRole],
    );

    // check role authorization, authorize everyone if no authorize is supplied
    return { isAuthorized };
};

export default useAuthorization;
